import { render, staticRenderFns } from "./CprPlusPointLimit.vue?vue&type=template&id=f4d01072&scoped=true&"
import script from "./CprPlusPointLimit.vue?vue&type=script&lang=js&"
export * from "./CprPlusPointLimit.vue?vue&type=script&lang=js&"
import style0 from "./CprPlusPointLimit.vue?vue&type=style&index=0&id=f4d01072&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4d01072",
  null
  
)

export default component.exports